<template>
	<b-modal ref="modal" :title="`Edit sound for ${curUserEventType.event_name||curUserEventType.event_type}`" :busy="loading>0 || saving">
		<b-form @submit.stop.prevent="save()" id="userEventTypeEditForm">
			<div v-if="loading > 0">
				<b-form-group>
					<b-skeleton width="50%"/>
				</b-form-group>
				<b-form-row busy>
					<b-col>
						<b-form-group>
							<b-skeleton type="input"/>
						</b-form-group>
					</b-col>
				</b-form-row>
			</div>
			<div v-else>
				<b-form-group :description="`Hide from ${curUserEventType.event_alert_type == 'alert' ? 'alert' : 'chat'} widget`" v-if="!['alert','default','chat'].includes(curUserEventType.event_type)">
					<b-form-checkbox switch v-model="curUserEventType.status" value="disabled" unchecked-value="enabled"> Disable {{curUserEventType.event_alert_type == 'alert' ? 'alert' : 'message'}}</b-form-checkbox>
				</b-form-group>
				<b-form-row v-if="curUserEventType?.status != 'disabled' || ['alert','default','chat'].includes(curUserEventType.event_type)">
					<b-col>
						<b-form-group v-if="['delete','clear','default','chat'].includes(curUserEventType.event_type)" label="Sounds" description="Audio files only.">
							<pipi-pupu-file ref="fileUpload" v-model="curUserEventType.media" accept="audio/*" :multiple="true"></pipi-pupu-file>
						</b-form-group>
						<b-form-group v-else label="Media" description="Audio and image files.">
							<pipi-pupu-file ref="fileUpload" v-model="curUserEventType.media" accept="audio/*,image/*" :multiple="true"></pipi-pupu-file>
						</b-form-group>
					</b-col>
				</b-form-row>
			</div>
		</b-form>
		<b-alert variant="danger" :show="!!error" class="mt-4 mb-0">{{error}}</b-alert>
		<template #modal-footer="{cancel}">
			<b-spinner v-show="loading>0 || saving" small label="Loading"></b-spinner>
			<b-button variant="success" type="submit" form="userEventTypeEditForm">Save</b-button>
			<b-button @click="cancel()">Close</b-button>
		</template>
	</b-modal>
</template>

<script>
import PipiPupuFile from '../../../components/PipiPupuFile.vue';

export default {
	data() { return {
		loading: 0,
		error: null,
		curUserEventType: {},
		saving: false,
	}; },
	components: {
		PipiPupuFile,
	},
	methods: {
		async show(messageType) {
			try {
				this.$refs.modal.show();
				this.loading++;
				this.error = null;
				this.curUserEventType = await this.$api.get(`userEventType/${messageType}`);
			} catch(err) {
				console.error(err);
				this.error = err;
			} finally {
				this.loading--;
			}
		},
		async save() {
			try {
				this.saving = true;
				this.error = null;
				await this.$refs.fileUpload?.waitForUploads();
				await this.$api.post(`userEventType/${this.curUserEventType.event_type}`, {
					status: this.curUserEventType.status,
					media: (this.curUserEventType.media||[]).map(s => s.md5),
				});
				this.$refs.modal.hide();
				this.$emit('saved');
			} catch(err) {
				console.error(err);
				this.error = err;
			} finally {
				this.saving = false;
			}
		},
	}
}
</script>
